import React, { createContext, useContext, type ReactNode } from 'react';
import { useUserProfile } from '../hooks/useUserProfile';

type UserContextType = ReturnType<typeof useUserProfile>;

const UserContext = createContext<UserContextType | undefined>(undefined);

export function UserProvider({ children }: { children: ReactNode }) {
  const userProfile = useUserProfile();
  return <UserContext.Provider value={userProfile}>{children}</UserContext.Provider>;
}

export function useUser() {
  const context = useContext(UserContext);
  if (!context) throw new Error('useUser must be used within a UserProvider');
  return context;
}
